import { type FunctionComponent, useState } from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import Button from '@atlaskit/button/new';
import Link from '@atlaskit/link';
import SectionMessage from '@atlaskit/section-message';
import { Box, Inline, Stack, Text, xcss } from '@atlaskit/primitives';
import { getConfig } from '../../../../config/envConfig';
import { mcpInfoCardMessages } from '../McpInfoCard/messages';
import { MCP_SSE_MIGRATION_GUIDE_URL, MCP_DEPRECATED_SSE_ENDPOINT } from '../mcpUrls';

const sseBannerMessages = defineMessages({
  dismiss: {
    id: 'oauth.mcp.sseBanner.dismiss',
    defaultMessage: 'Dismiss',
    description: 'Button label to dismiss the SSE deprecation banner',
  },
});

const codeInlineStyle = xcss({
  fontSize: 'font.body.small',
  backgroundColor: 'color.background.neutral',
  paddingInline: 'space.050',
  paddingBlock: 'space.025',
  borderRadius: 'radius.xsmall',
});

const McpSseBanner: FunctionComponent = () => {
  const { formatMessage } = useIntl();
  const showSseBanner = getConfig().mcpPolicy.showSseDeprecationBanner;
  const [dismissed, setDismissed] = useState(false);

  if (!showSseBanner || dismissed) {
    return null;
  }

  return (
      <SectionMessage
        appearance="warning"
        title={formatMessage(mcpInfoCardMessages.sseMigrationTitle)}
      >
        <Stack space="space.100">
          <Text as="p">
            <FormattedMessage
              {...mcpInfoCardMessages.sseMigrationBody}
              values={{
                endpoint: (
                  <Box as="code" xcss={codeInlineStyle}>
                    {MCP_DEPRECATED_SSE_ENDPOINT}
                  </Box>
                ),
              }}
            />
          </Text>
          <Inline space="space.200" alignBlock="center">
            <Link
              href={MCP_SSE_MIGRATION_GUIDE_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FormattedMessage {...mcpInfoCardMessages.migrationGuide} />
            </Link>
            <Button
              appearance="subtle"
              onClick={() => setDismissed(true)}
            >
              <FormattedMessage {...sseBannerMessages.dismiss} />
            </Button>
          </Inline>
        </Stack>
      </SectionMessage>
  );
};

export default McpSseBanner;
